export const IconDivide = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M5 11h14a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2m7.002-7a2 2 0 1 0-.004 4 2 2 0 0 0 .004-4m0 12a2 2 0 1 0-.004 4 2 2 0 0 0 .004-4" />
    </svg>
  );
};
